import { render, staticRenderFns } from "./PromotionCreate.vue?vue&type=template&id=5c350123&scoped=true"
import script from "./PromotionCreate.vue?vue&type=script&lang=js"
export * from "./PromotionCreate.vue?vue&type=script&lang=js"
import style0 from "./PromotionCreate.vue?vue&type=style&index=0&id=5c350123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c350123",
  null
  
)

export default component.exports